import { api } from "@/services/api/createAPI";
import { getAuthToken } from "@/services/supabase/auth/actions/getAuthToken";

export const generateSuggestions = async (query: string, context: string) => {
  const token = await getAuthToken();
  const { data } = await api(token).post("/api/suggestion", { query, context });
  return data;
};
